import React, { useEffect } from 'react';
import AssessmentCreatorApp from './AssessmentCreatorApp';

const AssessmentCreator: React.FC = () => {
  useEffect(() => {
    // Add dark class for Assessment Creator theming
    document.documentElement.classList.add('dark');
    // Hide the main container padding
    const main = document.querySelector('main');
    if (main) {
      main.style.padding = '0';
      main.style.backgroundColor = 'hsl(0 0% 9%)';
    }

    return () => {
      document.documentElement.classList.remove('dark');
      if (main) {
        main.style.padding = '';
        main.style.backgroundColor = '';
      }
    };
  }, []);

  return (
    <div
      className="min-h-screen w-full bg-background assessment-creator-root"
    >
      <AssessmentCreatorApp />
    </div>
  );
};

export default AssessmentCreator;
